// R285 - the kitchen TV's two sounds, WebAudio only (the repo has no audio assets; same
// approach as the Board's ping). Each player swallows its own errors: a blocked or missing
// audio device must never break the board.

export function createTvAudio(): AudioContext | null {
  try {
    const Ctx =
      window.AudioContext ??
      (window as unknown as { webkitAudioContext?: typeof AudioContext }).webkitAudioContext
    return Ctx ? new Ctx() : null
  } catch {
    return null
  }
}

// A short beep on a new task.
export function playBeep(ctx: AudioContext): void {
  try {
    const osc = ctx.createOscillator()
    const gain = ctx.createGain()
    osc.type = 'sine'
    osc.frequency.value = 880
    gain.gain.value = 0.08
    osc.connect(gain)
    gain.connect(ctx.destination)
    osc.start()
    osc.stop(ctx.currentTime + 0.15)
  } catch {
    // quiet by design
  }
}

// A loud ring when a card moves to ready: three square pulses, 660 Hz / 990 Hz alternating.
export function playRing(ctx: AudioContext): void {
  try {
    const PULSE_S = 0.25
    const GAP_S = 0.1
    const freqs = [660, 990, 660]
    const t0 = ctx.currentTime
    freqs.forEach((hz, i) => {
      const osc = ctx.createOscillator()
      const gain = ctx.createGain()
      osc.type = 'square'
      osc.frequency.value = hz
      gain.gain.value = 0.3
      osc.connect(gain)
      gain.connect(ctx.destination)
      const start = t0 + i * (PULSE_S + GAP_S)
      osc.start(start)
      osc.stop(start + PULSE_S)
    })
  } catch {
    // quiet by design
  }
}
